import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';

import './Navigation.scss';

class Navigation extends Component {
  render() {
    let back;
    
    if(this.props.onClickBackward !== undefined) {
      back = <Button color="link" className="back" onClick={this.props.onClickBackward} disabled={this.props.backwardDisabled}>Previous</Button>;
    }

    return (
      <div className="buttons-container">
        <Button color="primary" size="lg" type="submit" onClick={this.props.onClickForward} disabled={this.props.forwardDisabled}>Next</Button>
        {back}
      </div>);
  }
}

Navigation.defaultProps= {
  onClickForward:() => {},
  forwardDisabled: false,
  backwardDisabled: false
};

Navigation.propTypes = {
  onClickForward: PropTypes.func,
  onClickBackward: PropTypes.func,
  forwardDisabled: PropTypes.bool,
  backwardDisabled: PropTypes.bool
};
export default Navigation;


// WEBPACK FOOTER //
// ./src/components/Navigation/Navigation.js